import { useState } from 'react';
import { Controller } from 'react-hook-form';
import {
  IconUp,
  IconDown,
  ClickOutsideDetector,
  ButtonPseudo,
  ButtonSize,
} from '@ui/src';
import { EditNotificationsValues } from '../../hoc/center/types';
import { NotificationEditColumnRowTypes } from './types';

import cn from './styles.module.css';

const NotificationEditColumnRow = ({
  title,
  list,
  placeholder,
  name,
  editIssueControl,
  error,
  disabled,
  withAssignToMe,
  setEditIssueValue,
  currentUser,
}: NotificationEditColumnRowTypes) => {
  const [menuVisible, setMenuVisible] = useState(false);

  return (
    <div className={cn.notificationEditColumnFormGroup}>
      <div className={cn.title}>
        {title}
        {withAssignToMe && setEditIssueValue && (
          <ButtonPseudo
            size={ButtonSize.SMALL}
            text="Assign to me"
            className={cn.assignToMe}
            onClick={() =>
              setEditIssueValue(
                name as keyof EditNotificationsValues,
                currentUser?.id,
              )
            }
          />
        )}
      </div>
      <Controller
        control={editIssueControl}
        defaultValue=""
        name={name as keyof EditNotificationsValues}
        render={({ field: { value: inputValue, onChange: onChangeInput } }) => (
          <div className={cn.listWrapper}>
            <ClickOutsideDetector setOptionsListVisible={setMenuVisible}>
              <>
                <button
                  type="button"
                  className={cn.listButton}
                  onClick={() => setMenuVisible(!menuVisible)}
                  disabled={disabled}
                >
                  {inputValue
                    ? list?.find((item) => item.value === inputValue)?.name
                    : placeholder}
                  {!disabled && (
                    <div>{menuVisible ? <IconUp /> : <IconDown />}</div>
                  )}
                </button>
                {menuVisible && (
                  <div className={cn.listValues}>
                    {list?.map((item) => (
                      <button
                        type="button"
                        key={item.value}
                        className={`${cn.listValuesButton} ${
                          inputValue === item?.value ? cn.active : ''
                        }`}
                        onClick={() => {
                          onChangeInput(item.value);

                          setMenuVisible(false);
                        }}
                      >
                        {item.name}
                      </button>
                    ))}
                  </div>
                )}
              </>
            </ClickOutsideDetector>
            {error && <div className={cn.rowError}>{error}</div>}
          </div>
        )}
      />
    </div>
  );
};

export default NotificationEditColumnRow;
